import { createFileRoute } from '@tanstack/react-router'

import { FinishCards } from '~/boundedContext/cards/pages/finish-cards'

export const Route = createFileRoute('/demo/_layout/cards/finish')({
  component: FinishCards,
})
